<jhi-bary-card titleKey="ASSOCIATION_CARD.TITLE">
  <div body>
    <div class="row" *ngIf="description">
      <div class="col-12">
        <p class="text-lead">{{ description }}</p>
      </div>
    </div>
    <ul class="striped list-unstyled" *ngIf="!editable">
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.LEGAL_STATUS' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-company-Legal-status">{{ user?.companyLegalStatus }}</span>
      </li>
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.ASSOCIATION.NAME' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-association-name">{{ user?.companyName }}</span>
      </li>
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.SIRET_NUMBER' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-siret">{{ user?.siret }}</span>
      </li>
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.VAT_NUMBER' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-vat-number">{{ user?.vatNumber }}</span>
      </li>
    </ul>
    <form autocomplete="off" *ngIf="editable">
      <div class="row">
        <div class="col-12">
          <jhi-bary-input-select
            data-id-cypress="select-legal-status"
            [control]="getAssociationControl('companyLegalStatus')"
            [label]="'LABEL.LEGAL_STATUS' | translate"
            [id]="'association.companyLegalStatus'"
            [options]="legalStatusOptions"
          >
          </jhi-bary-input-select>
        </div>
        <div class="col-12">
          <jhi-bary-input-text
            data-id-cypress="input-association-name"
            [control]="getAssociationControl('companyName')"
            [id]="'association.name'"
            [label]="'LABEL.ASSOCIATION.NAME' | translate"
          >
          </jhi-bary-input-text>
        </div>
        <div class="col-12">
          <jhi-bary-siret
            data-id-cypress="input-siret"
            [control]="getAssociationControl('siret')"
            [autoSearch]="false"
            [searchButton]="false"
            (siretChange)="getAssociationControl('siret').setValue($event)"
            [id]="'association.siret'"
          >
          </jhi-bary-siret>
        </div>
        <div class="col-12">
          <jhi-bary-input-text
            data-id-cypress="input-vat-number"
            [control]="getAssociationControl('vatNumber')"
            [id]="'association.vatNumber'"
            [label]="'LABEL.VAT_NUMBER' | translate"
          >
          </jhi-bary-input-text>
        </div>
      </div>
    </form>
  </div>
  <div footer class="text-right p-3" *ngIf="switchButton">
    <jhi-bary-button *ngIf="!editable" [label]="'BTN.MODIFY' | translate" size="sm" icon="pen" color="primary" (click)="editable = true"></jhi-bary-button>
    <jhi-bary-button *ngIf="editable" [label]="'BTN.CANCEL' | translate" size="sm" icon="times" color="danger" (click)="editable = false; saveEvent.emit(false)"></jhi-bary-button>
    <jhi-bary-button
      *ngIf="editable"
      [label]="'BTN.SAVE' | translate"
      size="sm"
      icon="save"
      color="primary"
      (click)="editable = false; saveEvent.emit(true)"
      [disabled]="associationForm.invalid"
    ></jhi-bary-button>
  </div>
</jhi-bary-card>
